<template>
  <div class="file-pres file-pres-added">
    <div class="file-pres__main">
      <div class="file-pres__icon">
        <span class="ns-icon-ico012 ns-x-large-icon"/>
      </div>
      <div class="m-l-10">
        <div class="Title1">{{ computedListTitle }}</div>
        <text-string class="m-t-10" label-id="txt040" :props="computedPatientName"/>
        <div class="Body3">{{ item.received | displayDateString }}</div>
      </div>

      <smd-spacer/>
      <span class="ns-icon-ico025 file-pres__remove-btn"
            @click.prevent.stop="remove">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
      </span>
      <div class="file-pres__coupon file-pres-added__coupon m-t-25 m-b-10"
           v-if="showCoupon && !$isMobile">
        <smd-coupon :class="{'m-b-20': item.coupons.length > 1 && index !== item.coupons.length - 1}"
                    v-for="(coupon, index) in item.coupons"
                    :key="index"
                    :item="coupon"
                    :image="couponImage"
                    :small="true"
                    :title="coupon.shortname"/>
      </div>
    </div>

    <div class="file-pres__coupon file-pres-added__coupon m-t-25 m-b-10"
         v-if="showCoupon && $isMobile">
      <smd-coupon :class="{'m-b-20': item.coupons.length > 1 && index !== item.coupons.length - 1}"
                  v-for="(coupon, index) in item.coupons"
                  :key="index"
                  :item="coupon"
                  :image="couponImage"
                  :small="true"
                  :title="coupon.shortname"/>
    </div>
    <div class="file-pres__other"
         v-else-if="!showCoupon"
         :class="{'m-t-20': !getAllListedItems}">
      <smd-textarea v-if="!getAllListedItems"
                    :placeholder="getElementString('txt209')"
                    :value="remarks"
                    @input="updateRemarks"/>
      <div class="smd-checkbox__row m-t-10 m-l-50 m-b-5">
        <smd-checkbox :label="getElementString('txt203')"
                      :model-value="getAllListedItems"
                      @change="changeCheckboxValue"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {formatDate} from "@/utils/dates";
  import debounce from 'lodash/debounce';
  import GetElementString from "@/mixins/get-element-string";
  import {getPrescriptionCoupon} from '@/utils/medicine';
  import {getCouponLogo} from '@/reference/coupon';
  import {
    GETTER_DOCTOR_PATIENT_PARTNER,
  } from "@/store/types";

  export default {
    name: "file-pres-added",
    mixins: [GetElementString],
    props: {
      getAllListedItems: {type: Boolean, default: true},
      index: {type: Number},
      item: {type: Object},
      showCoupon: {type: Boolean, default: false},
      remarks: {type: String}
    },
    computed: {
      ...mapGetters({
        doctorPatientPartner: GETTER_DOCTOR_PATIENT_PARTNER,
      }),
      computedListTitle() {
        let stringType = '';

        switch (this.item.pagetype) {
          case 'prescription':
            stringType = 'Prescription';
            break;
          case 'image':
            stringType = 'Image';
            break;
          case 'customform':
            stringType = this.item.customform;
            break;
        }

        return `${stringType} from ${this.item.doctorname}`
      },
      computedPatientName() {
        const {patient} = this.doctorPatientPartner[this.item.token];
        return {'strings': [this.item.patientname || patient.name, '']}
      },
      couponImage() {
        const coupon = getPrescriptionCoupon(this.item);
        return getCouponLogo(coupon);
      },
    },
    methods: {
      changeCheckboxValue() {
        this.$emit('change-checkbox', this.index, !this.item.partial, '');
      },
      remove() {
        this.$emit('remove');
      },
      updateRemarks: debounce(function (remarks) {
        this.$emit('update-remarks', this.index, this.item.partial, remarks)
      }, 450),
    },
    filters: {
      displayDateString(isoDate) {
        const date = formatDate(isoDate, 'MMM DD, YYYY');
        const time = formatDate(isoDate, 'h:mm A');
        return `Sent on ${date} at ${time}`
      },
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .file-pres-added__coupon {
    @include responsive(desktop) {
      position: relative;
      width: unset !important;
      height: unset !important;
    }
  }
</style>